interface IRenewIconProps {
	size?: number;
	color?: string;
}

export function RenewIcon({
	size = 24,
	color = 'currentColor',
}: IRenewIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.2298 2C21.6545 2.00006 21.999 2.34446 21.999 2.76924V7.88646C21.9991 7.89649 21.9982 7.90648 21.998 7.91651C21.9972 7.95057 21.9931 7.98384 21.988 8.01667C21.9637 8.17195 21.8943 8.32168 21.7746 8.44135C21.7206 8.49541 21.6583 8.53596 21.5943 8.57056C21.5714 8.58301 21.5495 8.5975 21.5252 8.60762C21.4727 8.62938 21.4183 8.64407 21.363 8.65369C21.3203 8.66117 21.2766 8.66559 21.2318 8.66571L16.1015 8.66671C15.6767 8.66671 15.3323 8.32229 15.3323 7.89748C15.3323 7.47266 15.6767 7.12824 16.1015 7.12824H19.3738L18.3692 6.12363C16.6532 4.47942 14.3749 3.5385 11.9999 3.53847C10.3265 3.53847 8.69084 4.03511 7.29939 4.96476C5.90791 5.89452 4.82283 7.21574 4.18239 8.76186C3.54197 10.308 3.37417 12.0094 3.70061 13.6507C4.02711 15.2921 4.83296 16.8003 6.01633 17.9837C7.1997 19.167 8.70792 19.9729 10.3493 20.2994C11.9906 20.6258 13.6921 20.458 15.2381 19.8176C16.7842 19.1772 18.1055 18.0921 19.0352 16.7006C19.9649 15.3092 20.4615 13.6735 20.4615 12.0001C20.4615 11.5753 20.806 11.2308 21.2308 11.2308C21.6555 11.2309 22 11.5753 22 12.0001C22 13.9779 21.4131 15.9115 20.3143 17.556C19.2156 19.2002 17.6541 20.4821 15.8271 21.2389C13.9999 21.9958 11.9886 22.1937 10.0488 21.8078C8.10912 21.4219 6.32704 20.4699 4.92858 19.0714C3.53012 17.673 2.57808 15.8909 2.19219 13.9512C1.80634 12.0114 2.00423 10.0002 2.7611 8.17292C3.51795 6.34589 4.79976 4.78446 6.44402 3.68571C8.08849 2.58693 10.0222 2 11.9999 2C14.6148 2.00003 17.1174 2.97287 19.0643 4.6753L19.4459 5.02486L20.4605 6.03949V2.76924C20.4605 2.34442 20.805 2 21.2298 2Z"
				fill={color}
			/>
		</svg>
	);
}
